import { useNavigate, useParams } from "react-router-dom";

import LayoutFullScreen from "@/ui/layouts/LayoutFullScreen";
import ErrorBoundary from "@/ui/organisms/ErrorBoundary";

import {
    ViewDatabaseGuard,
    ViewDealActivities,
    ViewTopBar,
    ViewNewExperienceSection,
    ViewNavigationSidebar,
} from "@/ui/compositionRootUI";

import { routerPaths } from "@/ui/router/routerPaths";
import ErrorMessage from "@/ui/atoms/ErrorMessage";
import LayoutFillParentCentered from "@/ui/layouts/LayoutFillParentCentered";

const PageDealActivities = () => {
    const navigate = useNavigate();
    const { projectId, databaseId } = useParams();

    const parsedProjectId =
        projectId !== undefined ? parseInt(projectId, 10) : undefined;
    const parsedDatabaseId =
        databaseId !== undefined ? parseInt(databaseId, 10) : undefined;
    const isValidIdTypeGuard = (value: unknown): value is number =>
        typeof value === "number" && !isNaN(value);
    const handleBack = () => {
        if (projectId === undefined || databaseId === undefined) {
            return;
        }
        return navigate(
            routerPaths.projects.read({
                databaseId,
                projectId,
                tab: "documents",
            }),
        );
    };

    const handleAddFileButtonClicked = () => {
        return navigate(routerPaths.files.upload.url());
    };

    return (
        <LayoutFullScreen
            TopBarProps={{
                sx: {
                    backgroundColor: "var(--proda-white-110)",
                },
                onLogoClick: () => navigate(routerPaths.main.default()),
            }}
            MainContentProps={{
                sx: {
                    backgroundColor: "var(--proda-white)",
                    borderTop: "1px solid var(--primary-color)",
                },
            }}
            contentTopBar={<ViewTopBar />}
            contentTopBarBanner={<ViewNewExperienceSection />}
            contentSidebar={
                <ViewNavigationSidebar
                    handleUploadFileButtonClicked={handleAddFileButtonClicked}
                />
            }
        >
            <ErrorBoundary>
                <ViewDatabaseGuard>
                    {!isValidIdTypeGuard(parsedProjectId) ||
                    !isValidIdTypeGuard(parsedDatabaseId) ? (
                        <LayoutFillParentCentered>
                            <ErrorMessage>
                                The provided project ID or database ID is
                                invalid. Please check the URL and try again.
                            </ErrorMessage>
                        </LayoutFillParentCentered>
                    ) : (
                        <ViewDealActivities
                            projectId={parsedProjectId}
                            databaseId={parsedDatabaseId}
                            handleBackButtonClicked={handleBack}
                            sx={{
                                margin: "1rem 0",
                            }}
                        />
                    )}
                </ViewDatabaseGuard>
            </ErrorBoundary>
        </LayoutFullScreen>
    );
};

export default PageDealActivities;
